import { OverlayRef } from '@angular/cdk/overlay';
import { TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';

export interface OverlayCloseEvent {
  type: 'backdropClick' | 'close';
  data: string | undefined;
}

export class CustomOverlayRef {
  private readonly _afterClosed$ = new Subject<OverlayCloseEvent>();

  constructor(
    public readonly overlay: OverlayRef,
    public readonly content: TemplateRef<string> | '',
    public readonly data?: string,
  ) {}

  public close(data?: string): void {
    this._close({ type: 'close', data });
  }

  private _close(event: OverlayCloseEvent): void {
    this.overlay.dispose();
    this._afterClosed$.next(event);
    this._afterClosed$.complete();
  }
}
